import UserStore from './stores/UserStore';

const repositoryProps = {};

const storeProps = {};

export const stores = {
  userStore: new UserStore(),
};
